// Weekly challenge puzzles: extra puzzles for subscribers, one per game in the weeks a game has one. See
// docs/weekly-challenge-puzzles.md.

import type { GameType, SimpleDate } from './types';

/** A released challenge, as /api/challenges lists it: enough to show and link it, never the puzzle. */
export interface ChallengeListing {
  /** The Monday of its week. */
  week: SimpleDate;
  gameType: GameType;
  boardId: number;
  difficulty: number;
  /** Grid size in cells; null when the board's data doesn't say. */
  width: number | null;
  height: number | null;
  /** For a Stars challenge, how many stars go in each row, column and region. */
  starsPerUnit?: number;
}

/**
 * How a challenge's rules differ from its game's dailies, for its card and paywall: a Stars challenge with
 * other than the dailies' two stars a row. Undefined when they don't differ.
 */
export const challengeRulesNote = ({ starsPerUnit }: ChallengeListing): string | undefined =>
  starsPerUnit != null && starsPerUnit !== 2
    ? `${starsPerUnit} ${starsPerUnit === 1 ? 'star' : 'stars'} per row`
    : undefined;

/** The page listing every released challenge, this week's first. */
export const CHALLENGES_URL = '/challenges';

/** What a challenge is called where a daily shows its date: the board's heading, the pause dialog, a share. */
export const CHALLENGE_LABEL = 'Weekly Challenge';
